import type { UseQueryOptions } from '@tanstack/react-query'
import type {
	HttpGetPhotosetSpacesOptions,
	HttpGetPhotosetSpacesResponse
} from '@/features/photoset/http/photoset.http'
import { GET_PHOTOSET_IMAGES_LIST_RESPONSE_TYPE } from '@/features/photoset/queries/use-get-photoset-images-list'
import { useGetPhotosetSpaces } from '@/features/photoset/queries/use-get-photoset-spaces'
import { PhotosetImagesSearchParams } from '@/features/photoset/types'
import { useParsedSearchParams } from '@/hooks/use-parsed-search-params'

export const useGetPhotosetSpacesList = (
	promiseArgs: Omit<HttpGetPhotosetSpacesOptions, 'params'>,
	options?: Omit<
		UseQueryOptions<HttpGetPhotosetSpacesResponse>,
		'queryFn' | 'queryKey'
	>
) => {
	const { searchParams } = useParsedSearchParams(PhotosetImagesSearchParams)
	return useGetPhotosetSpaces(
		{
			...promiseArgs,
			params: {
				...searchParams,
				response_type: GET_PHOTOSET_IMAGES_LIST_RESPONSE_TYPE
			}
		},
		options
	)
}
